





















































import { Vue, Component, Inject, Prop } from "vue-property-decorator";
import { bytesToSize } from "@/helpers/file";
import { IUploadFile } from "@/models/uploadFiles";
import { IFilesProviderMethods } from "@/models/providers/files";

@Component({
  components: {
    "progress-bar": () =>
      import("@/components/app/global/fields/progressBar.vue")
  }
})
export default class FileList extends Vue {
  // Inject

  @Inject({ from: "filesProviderMethods" })
  public readonly $filesProviderMethods!: IFilesProviderMethods;

  // Props

  @Prop({ required: true })
  public attachments!: IUploadFile[];

  @Prop({ default: false })
  public isProcessing!: boolean;

  // Methods
  public isAllowed(fileObj) {
    return (
      this.$filesProviderMethods.isAllowed(fileObj.file.type) &&
      !this.$filesProviderMethods.hasWrongSize(fileObj.file.size)
    );
  }

  public getErrorLabel(fileObj) {
    return fileObj.hasError
      ? fileObj.errorMessage
      : this.$filesProviderMethods.hasWrongSize(fileObj.file.size)
      ? this.$t("_sentence.wrong_file_size")
      : this.$t("_sentence.wrong_file_type");
  }

  public isImage(attachmentType) {
    return attachmentType.includes("image");
  }

  public fileSize(attachment: IUploadFile) {
    return bytesToSize(this.$_.get(attachment, "file.size", 0));
  }

  public remove(attachment) {
    if (attachment.isUploading || this.isProcessing) return;
    this.$filesProviderMethods.removeAttachment(attachment.name);
  }
}
